
import LoginCallback from './components/LoginCallback.vue'
import OktaVue, { NavigationGuardMixin } from './okta-vue'

export default OktaVue
export { NavigationGuardMixin, LoginCallback }
